module.exports = __webpack_public_path__ + "img/page.a162ab73.png";